import { useState } from "react";
import { ImageOff } from "lucide-react";

export const money = (v) =>
  v == null ? null : `$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function ProductThumb({ src, className = "h-9 w-9" }) {
  const [err, setErr] = useState(false);
  if (!src || err) {
    return (
      <div className={`shrink-0 rounded-sm bg-slate-100 flex items-center justify-center text-slate-300 border border-slate-200 ${className}`}>
        <ImageOff size={15} />
      </div>
    );
  }
  return (
    <img src={src} alt="" loading="lazy" onError={() => setErr(true)}
      className={`shrink-0 rounded-sm object-cover bg-white border border-slate-200 ${className}`} />
  );
}

/** Compact two-pill stock cell for the results table: Bodega 11 vs Tienda origen. */
export function StockCell({ r }) {
  if (r.stock_total == null) return <span className="text-slate-300">—</span>;
  const loc = r.ship_from_location || "T";
  return (
    <div className="flex flex-col gap-0.5 items-start" data-testid={`stock-cell-${r.id}`}>
      <span className={`inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5 text-[10px] font-medium ${r.stock_bodega > 0 ? "bg-[#EA580C]/10 text-[#9A3412] border-[#FED7AA]" : "bg-slate-100 text-slate-400 border-slate-200"}`}>
        B11 <span className="font-mono font-semibold">{r.stock_bodega ?? 0}</span>
      </span>
      <span title={`Tienda ${loc}`} className={`inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5 text-[10px] font-medium ${r.stock_store > 0 ? "bg-[#059669]/10 text-[#065F46] border-[#A7F3D0]" : "bg-slate-100 text-slate-400 border-slate-200"}`}>
        T{loc} <span className="font-mono font-semibold">{r.stock_store ?? 0}</span>
      </span>
    </div>
  );
}

/** Mini stat box used in the order detail drawer. */
export function StockMini({ label, value, tone }) {
  const tones = {
    slate: "border-slate-200 bg-white text-slate-900",
    orange: "border-[#FED7AA] bg-[#FFF7ED] text-[#9A3412]",
    green: "border-[#A7F3D0] bg-[#ECFDF5] text-[#065F46]",
  };
  return (
    <div className={`rounded-sm border p-2 text-center ${tones[tone]}`}>
      <div className="font-mono text-lg font-light leading-none">{value ?? 0}</div>
      <div className="text-[10px] uppercase tracking-wide mt-1 truncate">{label}</div>
    </div>
  );
}
